import { ReactNode } from 'react';
import { Permission, useGuard } from '@/hooks/useGuard';

interface AccessGuardProps {
    permission: Permission;
    children: ReactNode | { success: ReactNode; fallback: ReactNode };
}

function isNamedChildren(nodes: any): nodes is { success: ReactNode; fallback: ReactNode } {
    return Boolean(nodes.success);
}

export const AccessGuard = ({ permission, children }: AccessGuardProps) => {
    const hasAccess = useGuard(permission);
    const { success, fallback } = isNamedChildren(children) ? children : { success: children, fallback: null };
    if (!hasAccess) {
        return fallback;
    }
    return <>{success}</>;
};
